/* Imports */
import { defineStore } from 'pinia';

export const useContentfulFeatureFlagsStore = defineStore('contentfulFeatureFlags', {
  state: () => ({
    contentfulEnvSettings: {},
  }),
  getters: {
    getContentfulEnvSettings: (state) => state.contentfulEnvSettings,
    getFeatureFlagByName: (state) => (featureFlagName) => Boolean(state.contentfulEnvSettings?.[featureFlagName]),
  },
  actions: {
    setContentfulEnvSettings(payload) {
      this.contentfulEnvSettings = payload;
    },
  },
});

export default useContentfulFeatureFlagsStore;
